/**
 * Container Component
 * Standard max-width container with padding
 */

import React, { type ReactNode } from 'react';

interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

const sizeClasses = {
  sm: 'max-w-2xl',
  md: 'max-w-4xl',
  lg: 'max-w-6xl',
  xl: 'max-w-7xl',
};

const Container = React.forwardRef<HTMLDivElement, ContainerProps>(
  ({ children, className = '', size = 'lg', ...props }, ref) => {
    const sizeClass = sizeClasses[size];
    const baseClasses = 'mx-auto px-4 sm:px-6 lg:px-8 w-full';

    return (
      <div
        ref={ref}
        className={`${baseClasses} ${sizeClass} ${className}`}
        {...props}
      >
        {children}
      </div>
    );
  }
);

Container.displayName = 'Container';

export default Container;
